import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ProjectProgressStep from '../../../widgets/projectProgress/ProjectProgressStep'
import ProjectProgressTimeline from '../../../widgets/projectProgress/ProjectProgressTimeline'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getInviteValidate,
  getListBudgetReport,
  getProjectOverview,
} from '../../../redux/actions/projectOverview'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import WithdrawRequestStatusWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import { getWithdrawRequestStatus } from '../../../redux/actions/withdrawRequest'
import { getContractor } from '../../../redux/actions/contract'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import ApproverListWidget from '../../../widgets/ApproverDetail/ApproverListWidget'
import pathname from '../../../constants/pathname'
import ListBudgetReportWidget from '../../../widgets/listBudgetReportWidgets/ListBudgetReportWidget'
import { isEmpty } from 'lodash-es'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import { Panel, Table } from 'rsuite'
import ContractChangeExtendPeriodHistoryWidget from '../../../widgets/contractChangeExtendPeriod/ContractChangeExtendPeriodHistoryWidget'
import { contractExtendPeriodHistory } from '../../../redux/actions/contractExtendPeriod'
import ContractChangeHistoryWidget from '../../../widgets/contractChange/ContractChangeHistoryWidget'
import AIEvaluationResultWidget from '../../../widgets/aiEvaluation/AIEvaluationResultWidget'
import { getAiEvaluationResult } from '../../../redux/actions/aiEvaluation'
import OverviewCurrentStatus from '../../../widgets/projectProgress/OverviewCurrentStatus'

export default function Overview() {
  const { Column, HeaderCell, Cell } = Table
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  //const { projectId } = useParams()
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()
  const [contractorListSchema, setContractorListSchema] = useState()
  const [listBudgetReportSchema, setListBudgetReportSchema] = useState()
  const [changeExtendPeriodHistory, setChangeExtendPeriodHistory] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [verifyStatus, setVerifyStatus] = useState()

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
      setListBudgetReportSchema()
      handleChangeExtendPeriodHistory()
      handleGetVerifyStatus()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  useEffect(() => {
    if (schema) {
      schema?.forms?.progressStep?.current >= 4 && handleGetWithdrawRequestStatusSchema()
      schema?.forms?.progressStep?.current >= 3 && handleGetContractorListSchema()
      handleGetListBudgetReportSchema()
    }
  }, [schema])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      if (!projectId) {
        window.location.href = `/`
        window.opener = null
      } else {
        const invitedData = await getInviteValidate(projectId)
        //console.log(invitedData)
        if (!invitedData) {
          doneLoading()
          setIsLoading(false)
          window.location.href = `${pathname.proposal.inviteToProjectAcceptance}`
          window.opener = null
        } else {
          const result = await getProjectOverview(projectId)

          if (isEmpty(result?.projecCode)) {
            window.location.href = `/`
            window.opener = null
          } else {
            setSchema(result)
          }
        }
      }
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetWithdrawRequestStatusSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetContractorListSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _contractorListSchema = await getContractor(projectId)
      setContractorListSchema(_contractorListSchema.model)
    } catch (e) {
      console.log('e', e)
      // if (e?.response?.data) {
      //   setError({
      //     statusCode: e.response.data.status,
      //     errorMessage: e.response.data.errors?.message,
      //   })
      // } else {
      //   setError({})
      // }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetListBudgetReportSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _listBudgetReportSchema = await getListBudgetReport(projectId)
      setListBudgetReportSchema(_listBudgetReportSchema)
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleChangeExtendPeriodHistory = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log('dddddd')

      const response = await contractExtendPeriodHistory(projectId)
      setChangeExtendPeriodHistory(response)
      // setChangeExtendPeriodHistory(mock)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetVerifyStatus = async () => {
    try {
      const response = await getAiEvaluationResult(projectId)

      if (response) {
        setVerifyStatus(response)
      }
    } catch (e) {}
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} isNotCallApi />

        <ProjectBasicInfo schema={schema.forms.projectInfo} />

        <br />

        <ProjectProgressStep schema={schema.forms.progressStep} />

        <br />

        <OverviewCurrentStatus projectVersionId={projectId} />

        {/* ตารางงบประมาณ */}
        {listBudgetReportSchema && (
          <>
            <ListBudgetReportWidget schema={listBudgetReportSchema} />
            <br />
          </>
        )}

        {/* สถานะการขอเบิกงวดเงิน */}
        {withdrawRequestStatusSchema?.forms?.withdrawRequestStatus && (
          <>
            <WithdrawRequestStatusWidget
              schema={withdrawRequestStatusSchema.forms.withdrawRequestStatus}
            />
            <br />
          </>
        )}

        {/* ประวัติขอขยายระยะเวลา */}
        {changeExtendPeriodHistory && (
          <>
            <ContractChangeExtendPeriodHistoryWidget
              schema={changeExtendPeriodHistory}
              isOverview={true}
            />
            <br />
          </>
        )}

        <ContractChangeHistoryWidget projectId={projectId} />
        <br />

        {/* รายชื่อผู้อนุมัติทุนโครงการ */}
        {schema?.forms?.projectApprover && (
          <>
            <ApproverListWidget schema={schema.forms.projectApprover} />
            <br />
          </>
        )}
        {/* รายการผู้มีอำนาจลงนาม */}
        {contractorListSchema?.forms?.contractorList?.contractorList?.length > 0 && (
          <>
            <ContractSigningWidgets schema={contractorListSchema.forms.contractorList} />
            <br />
          </>
        )}

        <AIEvaluationResultWidget schema={verifyStatus} shaded showDetail={false} />

        <ProjectProgressTimeline schema={schema.forms.progressTimeLine} />
        <br />
      </SidebarProposal>
    </>
  )
}
